// @ts-nocheck
/* eslint-disable */
import { createReducer } from 'reduxsauce';
import produce from 'immer';
import { Types } from '../actions/cost_code_import';
import snakeCase from 'utils/snakeCase';
const validExcelExtension = [
  'xla',
  'xlam',
  'xlr',
  'xls',
  'xlsx',
  'xlsm',
  'xlsb',
  'xlt',
  'xltx',
  'xltm',
  'xlw',
  'xml',
];

function getFileExtension(name) {
  if (!name) {
    return;
  }
  const lastDot = name.lastIndexOf('.');
  const ext = name.substring(lastDot + 1);
  return ext;
}

const initialState = {
  isFullPage: false,
  step: 1,
  file: null,
  fileErr: '',
  columns: [],
  rows: [],
  systemFields: [],
  unidentifiedCategories: {
    categories: [],
    sub_categories: [],
  },
  shouldImportUnmatchedColumns: false,
  shouldImportUnidentifiedCategories: false,
  hasEmptyMandatoryFields: false,
  hasDuplicateRows: false,
  hasDefaultCategory: false,
};

const setFullPageLayout = (state, action) => {
  const {
    payload: { isFullPage },
  } = action;
  return {
    ...state,
    isFullPage,
  };
};

const setStep = (state, action) => {
  const {
    payload: { step },
  } = action;
  return {
    ...state,
    step,
  };
};

const addFile = (state, action) => {
  const {
    payload: { file },
  } = action;
  const fileExt = getFileExtension(file.name);

  if (validExcelExtension.indexOf(fileExt) == -1) {
    return {
      ...state,
      fileErr: 'Please select a proper file.',
    };
  }

  return {
    ...state,
    file,
  };
};

const removeFile = (state) => {
  return {
    ...state,
    file: null,
  };
};

const setColumnsAndRows = (state, action) => {
  const {
    payload: { columns, rows },
  } = action;

  const transformedColumns = columns.map((column) => ({
    label: column,
    value: snakeCase(column),
    isMatched: false,
    matchedValue: '',
  }));

  if (rows.length === 0) {
    return {
      ...state,
      columns: transformedColumns,
    };
  }

  const transformedRows = produce(rows, (draft) => {
    draft.forEach((row, index) => {
      draft[index] = row.reduce((acc, cell, i) => {
        acc[snakeCase(columns[i])] = cell;
        return acc;
      }, {});
      return row;
    });
  });

  return {
    ...state,
    columns: transformedColumns,
    rows: transformedRows,
  };
};

const getSystemFieldsSuccess = (state, action) => {
  const {
    payload: { headers },
  } = action;

  return {
    ...state,

    systemFields: headers.map((header) => ({
      label: header,
      value: snakeCase(header),
    })),
  };
};

const matchColumn = (state, action) => {
  const {
    payload: { columnIndex, value },
  } = action;

  return {
    ...state,
    columns: produce(state.columns, (draft) => {
      const index = draft.findIndex((column) => column.matchedValue === value);
      if (index !== -1) {
        draft[index].matchedValue = '';
        draft[index].isMatched = false;
      }

      draft[columnIndex].matchedValue = value;
      draft[columnIndex].isMatched = true;
    }),
  };
};

const unmatchColumn = (state, action) => {
  const {
    payload: { columnIndex },
  } = action;

  return {
    ...state,
    columns: produce(state.columns, (draft) => {
      draft[columnIndex].matchedValue = '';
      draft[columnIndex].isMatched = false;
    }),
  };
};

const removeEmptyMandatoryFields = (state) => {
  const { rows, columns } = state;

  // const categoryMatchedKey = columns.find(
  //   (column) => column.matchedValue === 'category',
  // )?.value;
  const costCodeMatchedKey = columns.find(
    (column) => column.matchedValue === 'accounting_code',
  )?.value;

  // const filteredRows = rows.filter(
  //   (row) => row[categoryMatchedKey] && row[costCodeMatchedKey],
  // );

  const filteredRows = rows.filter((row) => row[costCodeMatchedKey]);
  return {
    ...state,
    rows: filteredRows,
    hasEmptyMandatoryFields: filteredRows.length > rows.length,
  };
};

const removeDuplicateRows = (state) => {
  const { rows, columns } = state;

  const uniqueRows = {};

  const costCodeMatchedKey = columns.find(
    (column) => column.matchedValue === 'accounting_code',
  )?.value;

  rows.reduce((acc, row) => {
    uniqueRows[row[costCodeMatchedKey]] = row;
    return acc;
  }, {});

  const filteredRows = Object.keys(uniqueRows).map((row) => uniqueRows[row]);

  return {
    ...state,
    rows: filteredRows,
    hasDuplicateRows: filteredRows.length > rows.length,
  };
};

const checkUnidentifiedCategoriesSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    unidentifiedCategories: data,
  };
};

const setImportUnidentifiedCategories = (state, action) => {
  const {
    payload: { value },
  } = action;

  return {
    ...state,
    shouldImportUnidentifiedCategories: value,
  };
};

const setImportUnmatchedColumns = (state, action) => {
  const {
    payload: { value },
  } = action;

  return {
    ...state,
    shouldImportUnmatchedColumns: value,
  };
};

const checkDefaultCategorySuccess = (state, action) => ({
  ...state,
  hasDefaultCategory: action.payload.exists,
});

const reset = () => initialState;

const costCodeReducer = createReducer(initialState, {
  [Types.SET_FULL_PAGE_LAYOUT]: setFullPageLayout,
  [Types.SET_STEP]: setStep,
  [Types.ADD_FILE]: addFile,
  [Types.REMOVE_FILE]: removeFile,
  [Types.SET_COLUMNS_AND_ROWS]: setColumnsAndRows,
  [Types.GET_SYSTEM_FIELDS_SUCCESS]: getSystemFieldsSuccess,
  [Types.MATCH_COLUMN]: matchColumn,
  [Types.UNMATCH_COLUMN]: unmatchColumn,
  [Types.CHECK_UNIDENTIFIED_CATEGORIES_SUCCESS]:
    checkUnidentifiedCategoriesSuccess,
  [Types.SET_IMPORT_UNIDENTIFIED_CATEGORIES]: setImportUnidentifiedCategories,
  [Types.SET_IMPORT_UNMATCHED_COLUMNS]: setImportUnmatchedColumns,
  [Types.REMOVE_DUPLICATE_ROWS]: removeDuplicateRows,
  [Types.REMOVE_EMPTY_MANDATORY_FIELDS]: removeEmptyMandatoryFields,
  [Types.CHECK_DEFAULT_CATEGORY_SUCCESS]: checkDefaultCategorySuccess,
  [Types.RESET]: reset,
});

export default costCodeReducer;
